import formatTableJson from '@/config/tableComponentParams.js'
import { enbaleDisableStatus } from '@/config/status'
export default formatTableJson([
  {
    filed: 'name',
    label: '代理商名称',
    width: '180px'
  },
  {
    filed: 'distributorName',
    label: '所属经销商',
    width: '180px'
  },
  {
    filed: 'expiryDate',
    label: '有效期至',
    type: 'time',
    timeFormat: 'YYYY-MM-DD',
    width: '180px'
  },
  {
    filed: 'principal',
    label: '负责人',
    width: '200px'
  },
  {
    filed: 'status',
    label: '状态',
    type: 'status',
    statusProps: enbaleDisableStatus,
    formatFn: function(_, row) {
      return row.statusName
    }
  }
])
